import React from 'react';
export function ContactHeader() {
  return <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-647">
      <div className="animate-fade-up-in" data-id="element-648">
        <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-649">
          Get in <span className="text-[#00D4FF]" data-id="element-650">Touch</span>
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-651">
          Have questions? We're here to help. Reach out to us or stop by for a
          visit.
        </p>
      </div>
    </div>;
}